import { render, staticRenderFns } from "./PaymentCalendar.vue?vue&type=template&id=237b7244&"
import script from "./PaymentCalendar.vue?vue&type=script&lang=ts&"
export * from "./PaymentCalendar.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentCalendar.vue?vue&type=style&index=0&id=237b7244&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports